import { createApp } from 'vue';
import App from './App.vue';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import axios from "axios";
import router from "../router/router.js";
import PrimeVue from 'primevue/config';
// import 'primevue/resources/themes/aura-light-green/theme.css'
import 'primeicons/primeicons.css'
import Aura from '@primeuix/themes/aura';
import '@/assets/scss/style.min.css'
import '@/assets/css/player.css'
import store from '../src/store/index.js';
import 'vue-plyr/dist/vue-plyr.css'
import {
    isReservationPath,
    removeAuthorizationHeader,
    resetAuthenticationForGuest,
} from '@/services/guestSession';


axios.defaults.baseURL = localStorage.getItem("api_base_url") || "https://api.tarekmath.com/api";
// axios.defaults.baseURL = "http://192.168.1.26:8000/api";

const initialReservationGuestRoute = isReservationPath(window.location.pathname);
if (initialReservationGuestRoute) {
    // Run before the app mounts so even App-level startup requests are guest
    // requests on a direct /reservation page load.
    resetAuthenticationForGuest(store, axios);
} else {
    const token = localStorage.getItem("token");
    if (token) {
        axios.defaults.headers.common.Authorization = `Bearer ${token}`;
    }
}

axios.interceptors.request.use((config) => {
    const onReservationGuestRoute = router.currentRoute.value.matched
        .some(record => record.meta.forceGuest)
        || isReservationPath(window.location.pathname);

    // An endpoint can opt in only by setting both requiresAuth: true and its own
    // explicit Authorization header. Normal reservation requests are always guest.
    if (onReservationGuestRoute && config.requiresAuth !== true) {
        removeAuthorizationHeader(config.headers);
    }

    return config;
});

// Content protection (Features 6/7): when the API rejects a request because the
// student has no active subscription, route to the "Subscription Required" page
// and preserve the current location as the return URL.
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        const data = error?.response?.data;
        if (error?.response?.status === 403 && data?.code === 'subscription_required') {
            const current = router.currentRoute.value;
            if (current.path !== '/subscription-required') {
                const sub = data.subscribable || {};
                router.push({
                    path: '/subscription-required',
                    query: {
                        type: sub.type || undefined,
                        id: sub.id || undefined,
                        label: sub.label || undefined,
                        return: current.fullPath,
                    },
                });
            }
        }
        return Promise.reject(error);
    }
);

const app = createApp(App);
app.config.globalProperties.axios = axios;
app.use(PrimeVue, {
    theme: {
        preset: Aura,
        options: {
            prefix: 'p',
            darkModeSelector: false,
            cssLayer: false
        }
    }
});
app.use(router);
app.use(store);
app.mount('#app');
